<template>

    <div class="page-container">

        <header-band
            :back="true"
            @eventBack="eventBack"
        ></header-band>

        <email-redirect :title="$t('email_address_cleanfox')" :directDeleteAccount="true"></email-redirect>

    </div>

</template>

<script>
import Tag from '../modules/tag'

import HeaderBand from '../components/headers/HeaderBand'
import EmailRedirect from '../components/loginFlow/EmailRedirect'


export default {

    name: 'login-email',

    components: {
        EmailRedirect,
        HeaderBand
    },

    mounted() {

        Tag.pageViewAll(this, 'playstore_delete_account_login')
    },

    methods: {

        eventBack() {

            this.$router.push({path: '/'})
        }

    }
}
</script>

<style lang="scss" scoped>

.page-container {
    width: 100%;
    min-height: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
    }
}

</style>
